const TerpeneTranslator = {
  'Alpha Pinene': {
    aromas: 'Sharp, Piney',
    benefits: 'Anti-inflammatory, antibacterial, bronchodilator, aids memory',
  },
  'Beta Pinene': {
    aromas: 'Sharp, Piney',
    benefits: 'Anti-inflammatory, antibacterial, bronchodilator, aids memory',
  },
  // TEMP HACK TO SUPPORT CANVIEW as they don't have the alpha/beta distinction
  'Alpha Beta Pinene': {
    aromas: 'Piney, Sharp',
    benefits: 'Antibacterial, Anti-inflammatory, bronchodilator, aids memory',
  },
  'Alpha Bisabolol': {
    aromas: 'Sweet, fruity, nutty',
    benefits: 'Anti-inflammatory, antioxidant, pain relief, stress relief',
  },
  'Beta Caryophyllene': {
    aromas: 'Pepper, wood, spice',
    benefits: 'Anti-inflammatory, anti-anxiety, gastric protective, sleep aid, muscle relaxant',
  },
  Farnesene: {
    aromas: 'Sweet, wood, berry, apple',
    benefits: 'Anti-inflammatory, anti-fungal, antibacterial, sedative',
  },
  Guaiol: {
    aromas: 'Fresh, piney, wood, rose',
    benefits: 'Anti-inflammatory, anti-fungal, anti-parasitic, antioxidant',
  },
  Humulene: {
    aromas: 'Wood, earthy',
    benefits: 'Anticancer, anti-inflammatory, analgesic',
  },
  Limonene: {
    aromas: 'Lemon, orange',
    benefits: 'Anti-inflammatory, antidepressant, anti-anxiety, gastric protectant',
  },
  Linalool: {
    aromas: 'Floral',
    benefits: 'Analgesic, anaesthetic, anti-convulsant, anti-anxiety, sedative, anticancer',
  },
  Myrcene: {
    aromas: 'Floral, earthy, citrus',
    benefits: 'Sedative, muscle relaxant, anti-inflammatory',
  },
  Nerolidol: {
    aromas: 'Wood, citrus, apple, rose',
    benefits: 'Antimicrobial, anti-parasitic, antioxidant, anti-fungal',
  },
  Ocimene: {
    aromas: 'Sweet, earthy, herbaceous, citrus',
    benefits: 'Uplifting, anti-convulsant, anti-inflammatory, anti-viral, anti-fungal',
  },
  Terpineol: {
    aromas: 'Lemon, pine, sweet, woody',
    benefits: 'Antibacterial, anticancer, antioxidant, sedative',
  },
  Terpinolene: {
    aromas: 'Pine, clove',
    benefits: 'Anti-inflammatory, antioxidant, sedative, stress relief',
  },
  'Delta 3 Carene': {
    aromas: 'Sweet, piney, citrus',
    benefits: 'Anti-inflammatory, bone stimulant, memory retention',
  },
  Eucalyptol: {
    aromas: 'Fresh, minty, woody scent',
    benefits: 'Anti-inflammatory, antibacterial, antifungal, antioxidant',
  },
  Caryophyllene: {
    aromas: 'Spicy, woody, peppery',
    benefits: 'Anti-inflammatory, anti-anxiety, antioxidant, stress relief',
  },
  Geraniol: {
    aromas: 'Floral, citrus, fruity',
    benefits: 'Antioxidant, neuroprotective, antimicrobial',
  },
  Camphene: {
    aromas: 'Earthy, musky, herbal',
    benefits: 'Antioxidant, anti-inflammatory, cardiovascular health',
  },
  Isopulegol: {
    aromas: 'Minty, herbal',
    benefits: 'Anti-inflammatory, gastroprotective, neuroprotective',
  },
  Fenchol: {
    aromas: 'Lemon, camphor, pine',
    benefits: 'Antibacterial, antioxidant, anti-inflammatory',
  },
  'A-Cedrene': {
    aromas: 'Wood, cedar',
    benefits: 'Anti-inflammatory, antifungal, sedative',
  },
  'A-Phellandrene': {
    aromas: 'Citrus, spicy, minty',
    benefits: 'Antimicrobial, antifungal, antioxidant',
  },
};

export default TerpeneTranslator;
